var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4781_12034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0115 0C14.2454 0.209989 17.4349 2.08286 19.3191 5.95914C19.6143 6.56073 19.7675 7.2361 19.9491 7.88876C20.074 8.32577 19.9321 8.76277 19.7959 9.18275C18.5757 12.8661 16.0615 15.2157 12.3044 16.0897C8.68349 16.9296 5.46556 15.9818 2.75841 13.4279C1.39632 12.1453 0.51096 10.5619 0.0569304 8.74007C-0.0792784 8.20658 0.0172028 7.70148 0.181789 7.19637C1.33389 3.70602 3.69484 1.46992 7.19087 0.402951C8.1046 0.124858 9.04104 0.0113507 10.0115 0ZM9.9945 1.8445C8.70052 1.8445 7.5995 2.06016 6.33956 2.66175C4.06374 3.75709 2.55409 5.51646 1.86737 7.95687C1.82197 8.1101 1.83332 8.29739 1.87305 8.45062C2.2306 9.77866 2.87759 10.9478 3.8424 11.924C5.94796 14.0409 8.50188 14.9092 11.4417 14.3984C14.444 13.8763 16.6006 12.1793 17.7925 9.35868C18.3316 8.08173 18.3146 8.29739 17.7981 7.02043C16.5382 3.87628 13.4451 1.8445 9.9945 1.8445Z",
    fill: "#343A40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5412 8.19227C14.5412 10.6894 12.4924 12.7382 9.99519 12.7382C7.49803 12.7382 5.44922 10.6894 5.44922 8.1866C5.44922 5.68943 7.49803 3.64062 9.99519 3.64062C12.4924 3.6463 14.5412 5.69511 14.5412 8.19227ZM7.27101 8.19227C7.27101 9.67922 8.49689 10.9164 9.98951 10.9164C11.4765 10.9221 12.7137 9.69624 12.7194 8.20362C12.725 6.70532 11.4878 5.46242 9.98951 5.46809C8.49689 5.47377 7.27101 6.69965 7.27101 8.19227Z",
    fill: "#343A40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4781_12034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.3791,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewImg);
export default __webpack_public_path__ + "static/media/view-img.3a66ddce1489c062413468da02a81355.svg";
export { ForwardRef as ReactComponent };